import { PHONE_REGEX, looseEmail } from '@shopee/validators';
import { required } from '@shopee/validators';

import {
  prettifyPhoneNumber,
  localMobilePhoneValidator,
} from '@shopee-user/authentication-utils';

function phoneOrEmailValidator({
  requiredErrorMessage,
  phoneErrorMessage,
  emailErrorMessage,
}: {
  requiredErrorMessage: string;
  phoneErrorMessage: string;
  emailErrorMessage: string;
}) {
  return (
    value: string
  ): string | null | undefined | Promise<string | null | undefined> => {
    if (!value) {
      return requiredErrorMessage;
    } else if (PHONE_REGEX.test(value)) {
      return localMobilePhoneValidator(phoneErrorMessage)(value);
    } else {
      return looseEmail(emailErrorMessage)(value);
    }
  };
}

export const FORM_CONFIG = [
  {
    name: 'authKey',
    initial: '',
    validators: [
      phoneOrEmailValidator({
        requiredErrorMessage: 'msg_auth_mandatory_field',
        phoneErrorMessage: 'msg_auth_invalid_phone',
        emailErrorMessage: 'msg_auth_invalid_email',
      }),
    ],
    transform: prettifyPhoneNumber,
  },
  {
    name: 'password',
    initial: '',
    validators: [required('msg_auth_mandatory_field')],
  },
];
